import { App } from "./App";
const app = new App();
window.app = app;



//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 8
// module chunks = 0